export class OnboardUserRequest {

    constructor(public userName: string,
        public firstName: string,
        public lastName: string,
        public emailId: string,
        public phoneNumber: string,
        public systemType: string,
        public loginUrl: string,
        public redirectUrl: string,
        public applicationName: string
       
    ) {

    }
}


/** WEBPACK FOOTER **
 ** ./app/main/onboardingUserForgerock/onboard-user-request.ts
 **/